import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import "core-js/modules/es6.array.find";
import { logger } from '@origin-digital/reporting-client';
import { getContractFiltered } from './helpers';
// export for TEST
export var findSelectedProperty = function findSelectedProperty(properties, premiseId, contractAccountId) {
  // findBy contractAccountId
  if (contractAccountId) {
    var propertyFoundByAccountId = properties.find(function (p) {
      return (p.contractAccounts || []).find(function (contract) {
        return contract.contractAccountId === contractAccountId;
      }) != null;
    });

    if (propertyFoundByAccountId) {
      return propertyFoundByAccountId;
    }
  } // findBy premiseId


  if (premiseId) {
    var propertyFoundByPremiseId = properties.find(function (p) {
      return p.premiseId === premiseId;
    });

    if (propertyFoundByPremiseId) {
      return propertyFoundByPremiseId;
    }
  }

  var property = properties.find(function (p) {
    return p.premisePrimary;
  });
  return property ? property : properties[0];
};
export var derivedContractAccounts = function derivedContractAccounts(properties, queryParams, premiseId, contractAccountId) {
  if (!properties || !_Array$isArray(properties)) {
    return null;
  }

  var contractAccountIdPrecedence = queryParams ? !!queryParams.contractAccountId && !queryParams.premiseId : false;
  var selectedProperty = findSelectedProperty(properties, premiseId, contractAccountIdPrecedence ? queryParams.contractAccountId : undefined);

  if (!selectedProperty) {
    logger.error('@od/sac, properties are empty', properties);
    return null;
  }

  var contractsFiltered = getContractFiltered(selectedProperty);
  var contractAccountIdExists = contractsFiltered.find(function (account) {
    return account.contractAccountId === contractAccountId;
  });
  return {
    contractAccountId: contractAccountIdExists ? contractAccountId : contractsFiltered[0].contractAccountId,
    contractsFiltered: contractsFiltered,
    premiseId: contractsFiltered[0].premiseId
  };
};